import { cn } from "./useFunctions";

//navbar
export const ICON_HOME = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6585 9.70122L12.6585 3.57622C12.2815 3.24632 11.7185 3.24632 11.3415 3.57622L4.3415 9.70122C4.12448 9.89111 4 10.1654 4 10.4538V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V15C10 14.4477 10.4477 14 11 14H13C13.5523 14 14 14.4477 14 15V19C14 19.5523 14.4477 20 15 20H19C19.5523 20 20 19.5523 20 19V10.4538C20 10.1654 19.8755 9.89111 19.6585 9.70122Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_RETIREMENT = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_6055_79189" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5684 15.8841C16.5684 15.4296 16.7489 14.9937 17.0703 14.6723C17.3917 14.3509 17.8277 14.1703 18.2822 14.1703C18.7367 14.1703 19.1727 14.3509 19.4941 14.6723C19.8155 14.9937 19.9961 15.4296 19.9961 15.8841V23.28C19.9961 23.4315 19.9359 23.5768 19.8287 23.6839C19.7216 23.791 19.5763 23.8512 19.4248 23.8512C19.2733 23.8512 19.1279 23.791 19.0208 23.6839C18.9137 23.5768 18.8535 23.4315 18.8535 23.28V15.8841C18.8535 15.7326 18.7933 15.5873 18.6862 15.4802C18.579 15.373 18.4337 15.3129 18.2822 15.3129C18.1307 15.3129 17.9854 15.373 17.8782 15.4802C17.7711 15.5873 17.7109 15.7326 17.7109 15.8841V16.0801C17.7109 16.2316 17.6507 16.3769 17.5436 16.484C17.4365 16.5912 17.2912 16.6514 17.1396 16.6514C16.9881 16.6514 16.8428 16.5912 16.7357 16.484C16.6285 16.3769 16.5684 16.2316 16.5684 16.0801V15.8841Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5684 15.8841C16.5684 15.4296 16.7489 14.9937 17.0703 14.6723C17.3917 14.3509 17.8277 14.1703 18.2822 14.1703C18.7367 14.1703 19.1727 14.3509 19.4941 14.6723C19.8155 14.9937 19.9961 15.4296 19.9961 15.8841V23.28C19.9961 23.4315 19.9359 23.5768 19.8287 23.6839C19.7216 23.791 19.5763 23.8512 19.4248 23.8512C19.2733 23.8512 19.1279 23.791 19.0208 23.6839C18.9137 23.5768 18.8535 23.4315 18.8535 23.28V15.8841C18.8535 15.7326 18.7933 15.5873 18.6862 15.4802C18.579 15.373 18.4337 15.3129 18.2822 15.3129C18.1307 15.3129 17.9854 15.373 17.8782 15.4802C17.7711 15.5873 17.7109 15.7326 17.7109 15.8841V16.0801C17.7109 16.2316 17.6507 16.3769 17.5436 16.484C17.4365 16.5912 17.2912 16.6514 17.1396 16.6514C16.9881 16.6514 16.8428 16.5912 16.7357 16.484C16.6285 16.3769 16.5684 16.2316 16.5684 16.0801V15.8841Z"
        fill="currentColor"
      />
      <path
        d="M18.2822 14.1703L18.2822 10.1703L18.2822 14.1703ZM16.5684 16.0801H12.5684H16.5684ZM20.5684 15.8841C20.5684 16.4905 20.3275 17.072 19.8988 17.5007L14.2419 11.8438C13.1704 12.9154 12.5684 14.3687 12.5684 15.8841H20.5684ZM19.8988 17.5007C19.47 17.9294 18.8885 18.1703 18.2822 18.1703L18.2822 10.1703C16.7668 10.1703 15.3135 10.7723 14.2419 11.8438L19.8988 17.5007ZM18.2822 18.1703C17.6759 18.1703 17.0944 17.9294 16.6656 17.5007L22.3225 11.8438C21.251 10.7723 19.7976 10.1703 18.2822 10.1703L18.2822 18.1703ZM16.6656 17.5007C16.2369 17.072 15.9961 16.4905 15.9961 15.8841H23.9961C23.9961 14.3687 23.3941 12.9154 22.3225 11.8438L16.6656 17.5007ZM15.9961 15.8841V23.28H23.9961V15.8841H15.9961ZM15.9961 23.28C15.9961 22.3706 16.3573 21.4985 17.0003 20.8555L22.6572 26.5123C23.5144 25.655 23.9961 24.4923 23.9961 23.28H15.9961ZM17.0003 20.8555C17.6433 20.2125 18.5154 19.8512 19.4248 19.8512V27.8512C20.6371 27.8512 21.7999 27.3696 22.6572 26.5123L17.0003 20.8555ZM19.4248 19.8512C20.3341 19.8512 21.2062 20.2125 21.8492 20.8555L16.1924 26.5123C17.0497 27.3696 18.2124 27.8512 19.4248 27.8512V19.8512ZM21.8492 20.8555C22.4923 21.4985 22.8535 22.3706 22.8535 23.28H14.8535C14.8535 24.4923 15.3351 25.655 16.1924 26.5123L21.8492 20.8555ZM22.8535 23.28V15.8841H14.8535V23.28H22.8535ZM22.8535 15.8841C22.8535 14.6718 22.3719 13.509 21.5146 12.6517L15.8577 18.3086C15.2147 17.6656 14.8535 16.7935 14.8535 15.8841H22.8535ZM21.5146 12.6517C20.6573 11.7945 19.4946 11.3129 18.2822 11.3129V19.3129C17.3729 19.3129 16.5008 18.9516 15.8577 18.3086L21.5146 12.6517ZM18.2822 11.3129C17.0698 11.3129 15.9071 11.7945 15.0498 12.6517L20.7067 18.3086C20.0637 18.9516 19.1915 19.3129 18.2822 19.3129V11.3129ZM15.0498 12.6517C14.1925 13.509 13.7109 14.6718 13.7109 15.8841H21.7109C21.7109 16.7935 21.3497 17.6656 20.7067 18.3086L15.0498 12.6517ZM13.7109 15.8841V16.0801H21.7109V15.8841H13.7109ZM13.7109 16.0801C13.7109 15.1707 14.0722 14.2986 14.7152 13.6556L20.372 19.3125C21.2293 18.4552 21.7109 17.2925 21.7109 16.0801H13.7109ZM14.7152 13.6556C15.3582 13.0126 16.2303 12.6514 17.1396 12.6514V20.6514C18.352 20.6514 19.5147 20.1698 20.372 19.3125L14.7152 13.6556ZM17.1396 12.6514C18.049 12.6514 18.9211 13.0126 19.5641 13.6556L13.9073 19.3125C14.7645 20.1698 15.9273 20.6514 17.1396 20.6514V12.6514ZM19.5641 13.6556C20.2071 14.2986 20.5684 15.1707 20.5684 16.0801H12.5684C12.5684 17.2925 13.05 18.4552 13.9073 19.3125L19.5641 13.6556ZM20.5684 16.0801V15.8841H12.5684V16.0801H20.5684Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_6055_79189)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.71621 8.42667C7.58736 8.42667 6.68587 8.80371 6.06661 9.40756C5.77789 9.68813 5.54761 10.0231 5.38905 10.3932C5.2305 10.7632 5.14682 11.161 5.14284 11.5636C5.13769 11.9661 5.21422 12.3655 5.36779 12.7377C5.52136 13.1098 5.74879 13.447 6.03633 13.7287C6.63217 14.3132 7.4971 14.6816 8.58482 14.7091L9.14182 14.7233V22.29C9.14182 22.4425 9.3052 22.6933 9.68396 22.7081C10.0644 22.723 10.2655 22.4813 10.2827 22.3197L10.8414 16.9959H13.1551L13.7138 22.3202C13.7309 22.4813 13.932 22.723 14.3125 22.7081C14.6912 22.6933 14.8546 22.4425 14.8546 22.29V9.71091L15.6624 10.0782C16.2926 10.3645 16.7022 10.7295 16.9729 11.058C17.27 11.4196 17.5522 11.9143 17.6259 12.4582L17.6271 12.4696L17.6282 12.4788C17.6579 12.7713 17.9367 13.0238 18.2943 12.9946C18.6371 12.9672 18.881 12.6713 18.8559 12.3782C18.8307 12.1546 18.7801 11.9346 18.7051 11.7224C18.5395 11.2278 18.2842 10.7678 17.9521 10.3656C17.1192 9.35328 15.5944 8.42667 12.8986 8.42667H8.71621ZM5.2691 8.58948C6.12602 7.75427 7.32571 7.2841 8.71621 7.2841H12.898C15.8829 7.2841 17.7527 8.32498 18.8348 9.6395C19.2562 10.1503 19.58 10.7344 19.7899 11.3625C19.8813 11.639 19.9636 11.9475 19.9933 12.2754V12.2777C20.0807 13.2643 19.2981 14.0601 18.3857 14.1338C17.4511 14.2086 16.5942 13.5482 16.4925 12.605C16.4548 12.3399 16.3017 12.0412 16.0903 11.7841C16.0605 11.7478 16.0294 11.7126 15.9972 11.6784V22.29C15.9972 23.1954 15.1997 23.8164 14.3576 23.8496C13.5178 23.8827 12.6712 23.332 12.5775 22.4385L12.1262 18.1385H11.8703L11.4189 22.4391C11.3253 23.332 10.4786 23.8827 9.63883 23.8501C8.79676 23.817 7.99925 23.1954 7.99925 22.29V15.8116C6.89953 15.6802 5.94835 15.2432 5.23596 14.5434C4.83887 14.154 4.52468 13.6884 4.31232 13.1744C4.09996 12.6604 3.99381 12.1088 4.00028 11.5527C4.00571 10.9996 4.12057 10.4531 4.33824 9.94461C4.55591 9.43612 4.87208 8.97576 5.26852 8.59005M9.14182 9.54466V13.5911L8.5454 13.5648C7.78788 13.5305 7.26744 13.2734 6.93153 12.9438C6.75108 12.7648 6.60875 12.5512 6.51312 12.3158C6.41749 12.0803 6.37054 11.8279 6.3751 11.5739C6.37672 11.3169 6.42914 11.0627 6.52934 10.826C6.62954 10.5894 6.77554 10.3748 6.95895 10.1948C7.3 9.86287 7.8153 9.60808 8.54311 9.57323L9.14182 9.54466ZM7.99925 10.8478C7.85617 10.9108 7.73449 11.0141 7.649 11.145C7.5635 11.276 7.51788 11.4289 7.51766 11.5853C7.51538 11.8047 7.59593 11.9955 7.73189 12.128C7.78559 12.1811 7.87014 12.2463 7.99925 12.3017V10.8478ZM11.9982 2.14256C11.5437 2.14256 11.1078 2.32313 10.7864 2.64454C10.4649 2.96595 10.2844 3.40187 10.2844 3.85641C10.2844 4.31095 10.4649 4.74687 10.7864 5.06828C11.1078 5.38969 11.5437 5.57026 11.9982 5.57026C12.4528 5.57026 12.8887 5.38969 13.2101 5.06828C13.5315 4.74687 13.7121 4.31095 13.7121 3.85641C13.7121 3.40187 13.5315 2.96595 13.2101 2.64454C12.8887 2.32313 12.4528 2.14256 11.9982 2.14256ZM9.14182 3.85641C9.14182 3.09884 9.44276 2.3723 9.97844 1.83662C10.5141 1.30094 11.2407 1 11.9982 1C12.7558 1 13.4823 1.30094 14.018 1.83662C14.5537 2.3723 14.8546 3.09884 14.8546 3.85641C14.8546 4.61398 14.5537 5.34052 14.018 5.8762C13.4823 6.41188 12.7558 6.71282 11.9982 6.71282C11.2407 6.71282 10.5141 6.41188 9.97844 5.8762C9.44276 5.34052 9.14182 4.61398 9.14182 3.85641Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ICON_TAX = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5001 17.1771V18.9085M12.5001 8.58852V10.1999M10.7858 16.3885C10.995 16.6368 11.2582 16.8339 11.5554 16.9646C11.8525 17.0954 12.1757 17.1563 12.5001 17.1428C12.9959 17.1766 13.4854 17.0169 13.8659 16.6972C14.2463 16.3775 14.488 15.9227 14.5401 15.4285C14.488 14.9343 14.2463 14.4796 13.8659 14.1599C13.4854 13.8402 12.9959 13.6804 12.5001 13.7142C12.0043 13.748 11.5147 13.5883 11.1343 13.2686C10.7538 12.9489 10.5122 12.4941 10.4601 12C10.508 11.504 10.7485 11.0467 11.1299 10.7261C11.5114 10.4056 12.0033 10.2474 12.5001 10.2857C12.8187 10.2662 13.1378 10.3176 13.4342 10.4361C13.7306 10.5547 13.997 10.7375 14.2144 10.9714M12.5001 23.1257C18.5001 23.1257 22.7858 20.9999 22.7858 16.2685C22.7858 11.1257 20.2144 7.69709 15.0715 5.12566L17.0944 2.51995C17.1971 2.34899 17.2529 2.15389 17.2559 1.95444C17.259 1.75499 17.2093 1.55827 17.1118 1.38423C17.0144 1.21019 16.8726 1.06501 16.7009 0.963401C16.5293 0.861796 16.3338 0.807378 16.1344 0.805664H8.86578C8.66632 0.807378 8.47085 0.861796 8.29919 0.963401C8.12754 1.06501 7.98579 1.21019 7.88833 1.38423C7.79086 1.55827 7.74114 1.75499 7.74421 1.95444C7.74728 2.15389 7.80302 2.34899 7.90578 2.51995L9.92864 5.14281C4.78578 7.73138 2.21436 11.1599 2.21436 16.3028C2.21436 20.9999 6.50007 23.1257 12.5001 23.1257Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_SAVING = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4998 11V11.01M5.67283 8.37802C5.23423 8.04092 4.89737 7.58912 4.69949 7.07255C4.50161 6.55597 4.45041 5.99475 4.55154 5.4509C4.65268 4.90704 4.90222 4.40174 5.27258 3.99084C5.64294 3.57995 6.1197 3.27945 6.65016 3.12257C7.18063 2.96568 7.74414 2.95852 8.27842 3.10188C8.8127 3.24523 9.29694 3.53352 9.67762 3.93487C10.0583 4.33623 10.3206 4.83502 10.4355 5.37613C10.5504 5.91724 10.5135 6.47958 10.3288 7.00102"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 4V7.803C17.7376 8.51912 18.6799 9.65245 19.158 11H20.499C20.7642 11 21.0186 11.1054 21.2061 11.2929C21.3937 11.4804 21.499 11.7348 21.499 12V14C21.499 14.2652 21.3937 14.5196 21.2061 14.7071C21.0186 14.8946 20.7642 15 20.499 15H19.157C18.821 15.95 18.25 16.8 17.499 17.473V19.5C17.499 19.8978 17.341 20.2794 17.0597 20.5607C16.7784 20.842 16.3968 21 15.999 21C15.6012 21 15.2197 20.842 14.9384 20.5607C14.657 20.2794 14.499 19.8978 14.499 19.5V18.917C14.1686 18.9724 13.8341 19.0001 13.499 19H9.49901C9.16396 19.0001 8.82947 18.9724 8.49901 18.917V19.5C8.49901 19.8978 8.34098 20.2794 8.05967 20.5607C7.77837 20.842 7.39684 21 6.99901 21C6.60119 21 6.21966 20.842 5.93835 20.5607C5.65705 20.2794 5.49901 19.8978 5.49901 19.5V17.473C4.59298 16.663 3.95429 15.5969 3.6675 14.4159C3.3807 13.2348 3.45933 11.9946 3.89296 10.8592C4.32659 9.72387 5.09478 8.74697 6.09585 8.05783C7.09692 7.36869 8.28367 6.9998 9.49901 7H11.999L16.5 4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_BALANCE = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3476 6.65916C14.3769 6.6311 14.4031 6.62409 14.435 6.62836C15.4811 6.76868 16.4858 7.14625 17.3701 7.73715C18.5122 8.50027 19.4024 9.58493 19.928 10.854C20.4537 12.123 20.5912 13.5194 20.3232 14.8666C20.0553 16.2138 19.3938 17.4513 18.4225 18.4225C17.4513 19.3938 16.2138 20.0552 14.8666 20.3232C13.5194 20.5912 12.123 20.4537 10.854 19.928C9.58494 19.4024 8.50028 18.5122 7.73716 17.3701C7.14626 16.4858 6.76868 15.4811 6.62836 14.435C6.62409 14.4032 6.63111 14.3769 6.65916 14.3477C6.69166 14.3138 6.74932 14.2834 6.82394 14.2834H12.4828C13.4772 14.2834 14.2834 13.4772 14.2834 12.4828L14.2833 6.82394C14.2833 6.74932 14.3138 6.69166 14.3476 6.65916ZM14.6401 5.09873C13.5444 4.95176 12.74 5.86199 12.74 6.82394L12.74 12.4828C12.74 12.6249 12.6249 12.74 12.4828 12.74H6.82394C5.86199 12.74 4.95176 13.5444 5.09873 14.6401C5.27023 15.9187 5.7317 17.1467 6.45393 18.2275C7.38664 19.6234 8.71233 20.7114 10.2634 21.3539C11.8144 21.9963 13.5211 22.1644 15.1677 21.8369C16.8143 21.5094 18.3267 20.7009 19.5138 19.5138C20.7009 18.3267 21.5094 16.8142 21.8369 15.1677C22.1644 13.5211 21.9963 11.8144 21.3539 10.2633C20.7114 8.71231 19.6234 7.38662 18.2275 6.45392C17.1466 5.7317 15.9187 5.27023 14.6401 5.09873Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.54806 9.03562C3.5451 9.02685 3.54272 9.01467 3.54555 8.99502C3.74217 7.62801 4.3755 6.35155 5.36352 5.36352C6.35154 4.3755 7.62801 3.74217 8.99501 3.54555C9.01467 3.54272 9.02684 3.5451 9.03562 3.54806C9.04572 3.55147 9.05975 3.55875 9.0754 3.57372C9.10834 3.60523 9.13893 3.66249 9.13893 3.73729L9.13893 8.88171C9.13893 9.02377 9.02377 9.13893 8.88171 9.13893H3.73729C3.66249 9.13893 3.60523 9.10834 3.57372 9.0754C3.55875 9.05975 3.55147 9.04572 3.54806 9.03562ZM2.01794 8.7753C1.85938 9.87773 2.7781 10.6823 3.73729 10.6823H8.88171C9.87613 10.6823 10.6823 9.87613 10.6823 8.88171V3.73729C10.6823 2.7781 9.87773 1.85938 8.7753 2.01794C7.08023 2.26174 5.49742 3.04703 4.27223 4.27223C3.04703 5.49742 2.26174 7.08023 2.01794 8.7753Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3476 6.65916C14.3769 6.6311 14.4031 6.62409 14.435 6.62836C15.4811 6.76868 16.4858 7.14625 17.3701 7.73715C18.5122 8.50027 19.4024 9.58493 19.928 10.854C20.4537 12.123 20.5912 13.5194 20.3232 14.8666C20.0553 16.2138 19.3938 17.4513 18.4225 18.4225C17.4513 19.3938 16.2138 20.0552 14.8666 20.3232C13.5194 20.5912 12.123 20.4537 10.854 19.928C9.58494 19.4024 8.50028 18.5122 7.73716 17.3701C7.14626 16.4858 6.76868 15.4811 6.62836 14.435C6.62409 14.4032 6.63111 14.3769 6.65916 14.3477C6.69166 14.3138 6.74932 14.2834 6.82394 14.2834H12.4828C13.4772 14.2834 14.2834 13.4772 14.2834 12.4828L14.2833 6.82394C14.2833 6.74932 14.3138 6.69166 14.3476 6.65916ZM14.6401 5.09873C13.5444 4.95176 12.74 5.86199 12.74 6.82394L12.74 12.4828C12.74 12.6249 12.6249 12.74 12.4828 12.74H6.82394C5.86199 12.74 4.95176 13.5444 5.09873 14.6401C5.27023 15.9187 5.7317 17.1467 6.45393 18.2275C7.38664 19.6234 8.71233 20.7114 10.2634 21.3539C11.8144 21.9963 13.5211 22.1644 15.1677 21.8369C16.8143 21.5094 18.3267 20.7009 19.5138 19.5138C20.7009 18.3267 21.5094 16.8142 21.8369 15.1677C22.1644 13.5211 21.9963 11.8144 21.3539 10.2633C20.7114 8.71231 19.6234 7.38662 18.2275 6.45392C17.1466 5.7317 15.9187 5.27023 14.6401 5.09873Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.54806 9.03562C3.5451 9.02685 3.54272 9.01467 3.54555 8.99502C3.74217 7.62801 4.3755 6.35155 5.36352 5.36352C6.35154 4.3755 7.62801 3.74217 8.99501 3.54555C9.01467 3.54272 9.02684 3.5451 9.03562 3.54806C9.04572 3.55147 9.05975 3.55875 9.0754 3.57372C9.10834 3.60523 9.13893 3.66249 9.13893 3.73729L9.13893 8.88171C9.13893 9.02377 9.02377 9.13893 8.88171 9.13893H3.73729C3.66249 9.13893 3.60523 9.10834 3.57372 9.0754C3.55875 9.05975 3.55147 9.04572 3.54806 9.03562ZM2.01794 8.7753C1.85938 9.87773 2.7781 10.6823 3.73729 10.6823H8.88171C9.87613 10.6823 10.6823 9.87613 10.6823 8.88171V3.73729C10.6823 2.7781 9.87773 1.85938 8.7753 2.01794C7.08023 2.26174 5.49742 3.04703 4.27223 4.27223C3.04703 5.49742 2.26174 7.08023 2.01794 8.7753Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_EDUCATION = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 11.2218C11.2177 10.2738 9.29597 8.61605 3.78626 8.61605V20.4858C9.29597 20.4858 11.2177 22.1435 12.5 23.0915M12.5 11.2218V23.0915M12.5 11.2218C13.7823 10.2738 15.704 8.61605 21.2137 8.61605V20.4858C15.704 20.4858 13.7823 22.1435 12.5 23.0915M15.9045 0.985761V5.1549M18.9508 0.89319H7.50455C7.18475 0.892801 6.87123 0.981871 6.5994 1.15033L3.5874 3.02576L6.5994 4.89776C6.87123 5.06622 7.18475 5.15529 7.50455 5.1549H18.9508C19.2356 5.16298 19.5192 5.11387 19.7846 5.01046C20.0501 4.90705 20.2922 4.75145 20.4965 4.55286C20.7008 4.35428 20.8632 4.11673 20.9741 3.85429C21.085 3.59184 21.1421 3.30982 21.1421 3.0249C21.1421 2.73999 21.085 2.45797 20.9741 2.19552C20.8632 1.93307 20.7008 1.69553 20.4965 1.49694C20.2922 1.29836 20.0501 1.14276 19.7846 1.03935C19.5192 0.93594 19.2356 0.885109 18.9508 0.89319Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_DEBT = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 6C16.5 4.114 16.5 3.172 15.914 2.586C15.328 2 14.386 2 12.5 2C10.614 2 9.672 2 9.086 2.586C8.5 3.172 8.5 4.114 8.5 6M2.5 14C2.5 10.229 2.5 8.343 3.672 7.172C4.843 6 6.729 6 10.5 6H14.5C18.271 6 20.157 6 21.328 7.172C22.5 8.343 22.5 10.229 22.5 14C22.5 17.771 22.5 19.657 21.328 20.828C20.157 22 18.271 22 14.5 22H10.5C6.729 22 4.843 22 3.672 20.828C2.5 19.657 2.5 17.771 2.5 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.5 17.333C13.605 17.333 14.5 16.587 14.5 15.667C14.5 14.747 13.605 14 12.5 14C11.395 14 10.5 13.254 10.5 12.333C10.5 11.413 11.395 10.667 12.5 10.667M12.5 17.333C11.395 17.333 10.5 16.587 10.5 15.667M12.5 17.333V18M12.5 10.667V10M12.5 10.667C13.605 10.667 14.5 11.413 14.5 12.333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ICON_RISK = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0264 18.5L13.3661 3.5C12.9812 2.83333 12.019 2.83333 11.6341 3.5L2.97385 18.5C2.58895 19.1667 3.07007 20 3.83987 20H21.1604C21.9302 20 22.4113 19.1667 22.0264 18.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 16C14 16.8284 13.3284 17.5 12.5 17.5C11.6716 17.5 11 16.8284 11 16C11 15.1716 11.6716 14.5 12.5 14.5C13.3284 14.5 14 15.1716 14 16Z"
        fill="currentColor"
      />
      <path
        d="M12.5 12L12.5 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_INSURANCE = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2252 9.34159C16.5343 9.6435 16.5343 10.133 16.2252 10.4349L12.0044 14.5581C11.6953 14.86 11.1943 14.86 10.8852 14.5581L8.77481 12.4965C8.46575 12.1946 8.46575 11.7051 8.77481 11.4032C9.08387 11.1013 9.58495 11.1013 9.89401 11.4032L11.4448 12.9181L15.106 9.34159C15.415 9.03968 15.9161 9.03968 16.2252 9.34159Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8972 3.60599C12.6387 3.52624 12.3613 3.52624 12.1028 3.60599L5.00492 5.79558C4.37413 5.99017 3.98845 6.61109 4.10306 7.2475L5.21511 13.4224C5.62312 15.688 6.80725 17.719 8.71521 18.8861C9.41612 19.3148 10.1465 19.715 10.827 20.0057C11.524 20.3034 12.0953 20.4538 12.5 20.4538C12.9047 20.4538 13.476 20.3034 14.173 20.0057C14.8535 19.715 15.5839 19.3148 16.2848 18.8861C18.1928 17.719 19.3769 15.688 19.7849 13.4224L20.8969 7.2475C21.0116 6.61109 20.6259 5.99017 19.9951 5.79558L12.8972 3.60599ZM11.6262 2.13158C12.1949 1.95614 12.8051 1.95614 13.3738 2.13158L20.4717 4.32117C21.8594 4.74926 22.7079 6.11528 22.4558 7.5154L21.3437 13.6903C20.8769 16.2824 19.4961 18.746 17.1248 20.1966C16.3876 20.6475 15.5849 21.0901 14.8071 21.4223C14.0459 21.7475 13.2339 22 12.5 22C11.7661 22 10.9541 21.7475 10.1929 21.4223C9.4151 21.0901 8.61237 20.6475 7.87518 20.1966C5.50388 18.746 4.12307 16.2824 3.65626 13.6903L2.54421 7.5154C2.29206 6.11528 3.14056 4.74926 4.52829 4.32117L11.6262 2.13158Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2252 9.34159C16.5343 9.6435 16.5343 10.133 16.2252 10.4349L12.0044 14.5581C11.6953 14.86 11.1943 14.86 10.8852 14.5581L8.77481 12.4965C8.46575 12.1946 8.46575 11.7051 8.77481 11.4032C9.08387 11.1013 9.58495 11.1013 9.89401 11.4032L11.4448 12.9181L15.106 9.34159C15.415 9.03968 15.9161 9.03968 16.2252 9.34159Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8972 3.60599C12.6387 3.52624 12.3613 3.52624 12.1028 3.60599L5.00492 5.79558C4.37413 5.99017 3.98845 6.61109 4.10306 7.2475L5.21511 13.4224C5.62312 15.688 6.80725 17.719 8.71521 18.8861C9.41612 19.3148 10.1465 19.715 10.827 20.0057C11.524 20.3034 12.0953 20.4538 12.5 20.4538C12.9047 20.4538 13.476 20.3034 14.173 20.0057C14.8535 19.715 15.5839 19.3148 16.2848 18.8861C18.1928 17.719 19.3769 15.688 19.7849 13.4224L20.8969 7.2475C21.0116 6.61109 20.6259 5.99017 19.9951 5.79558L12.8972 3.60599ZM11.6262 2.13158C12.1949 1.95614 12.8051 1.95614 13.3738 2.13158L20.4717 4.32117C21.8594 4.74926 22.7079 6.11528 22.4558 7.5154L21.3437 13.6903C20.8769 16.2824 19.4961 18.746 17.1248 20.1966C16.3876 20.6475 15.5849 21.0901 14.8071 21.4223C14.0459 21.7475 13.2339 22 12.5 22C11.7661 22 10.9541 21.7475 10.1929 21.4223C9.4151 21.0901 8.61237 20.6475 7.87518 20.1966C5.50388 18.746 4.12307 16.2824 3.65626 13.6903L2.54421 7.5154C2.29206 6.11528 3.14056 4.74926 4.52829 4.32117L11.6262 2.13158Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_INVEST = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11H4C3.44772 11 3 11.4477 3 12V20H9V11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 8H15V20H21V9C21 8.44772 20.5523 8 20 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 4H10C9.44772 4 9 4.44772 9 5V20H15V5C15 4.44772 14.5523 4 14 4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_INHERIT = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 16V16.5H17.5H19.5C20.8839 16.5 22 17.6161 22 19V19.6324L14.4915 21.9788L7.63354 20.0782L7 19.9026V20.56V21.5H2V11.5H9.3797L15.4544 13.7682C15.4546 13.7682 15.4548 13.7683 15.455 13.7684C16.3796 14.1154 17 15.0087 17 16ZM5.5 20.5H6V20V13V12.5H5.5H3.5H3V13V20V20.5H3.5H5.5ZM14.3379 20.8922L14.4787 20.9308L14.6182 20.8875L20.5482 19.0475L21.1036 18.8752L20.8499 18.3519C20.6116 17.8604 20.0935 17.5 19.5 17.5H14.15C13.6598 17.5 13.1835 17.4275 12.7281 17.2757L12.7275 17.2755L10.8219 16.6429L11.1372 15.6921L13.0419 16.3243C13.0421 16.3244 13.0423 16.3245 13.0424 16.3245C13.0425 16.3245 13.0425 16.3245 13.0425 16.3245C13.1303 16.3537 13.2372 16.3701 13.3199 16.3809C13.4147 16.3933 13.5265 16.4043 13.6453 16.414C13.8835 16.4334 14.1683 16.4494 14.4393 16.462C14.7111 16.4746 14.9729 16.4841 15.1666 16.4904C15.2635 16.4935 15.3435 16.4959 15.3993 16.4975L15.4642 16.4992L15.4814 16.4997L15.4859 16.4998L15.487 16.4998L15.4874 16.4998L15.4875 16.4998L15.5 16L15.4875 16.4998L16 16.5127V16C16 15.422 15.6414 14.9067 15.1086 14.703L15.1086 14.703L15.1047 14.7015L9.28468 12.5315L9.20018 12.5H9.11H7.5H7V13V18.5V18.8814L7.36786 18.9822L14.3379 20.8922ZM12 7C12 4.51614 14.0161 2.5 16.5 2.5C18.9839 2.5 21 4.51614 21 7C21 9.48386 18.9839 11.5 16.5 11.5C14.0161 11.5 12 9.48386 12 7ZM13 7C13 8.93614 14.5639 10.5 16.5 10.5C18.4361 10.5 20 8.93614 20 7C20 5.06386 18.4361 3.5 16.5 3.5C14.5639 3.5 13 5.06386 13 7Z"
        fill="black"
        stroke="currentColor"
      />
    </svg>
  );
};
export const ICON_FUTURE = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 20H3V5M21 7L13 14L9 10L3 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_REPORT = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62903 17.1282C8.62903 16.7034 8.97565 16.359 9.40323 16.359H13.5323C13.9598 16.359 14.3065 16.7034 14.3065 17.1282C14.3065 17.553 13.9598 17.8974 13.5323 17.8974H9.40323C8.97565 17.8974 8.62903 17.553 8.62903 17.1282Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62903 14.0513C8.62903 13.6264 8.97565 13.2821 9.40323 13.2821H11.4677C11.8953 13.2821 12.2419 13.6264 12.2419 14.0513C12.2419 14.4761 11.8953 14.8205 11.4677 14.8205H9.40323C8.97565 14.8205 8.62903 14.4761 8.62903 14.0513Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 3.53846C10.9751 3.53846 8.92753 3.70582 7.49542 3.8447C6.90117 3.90233 6.43741 4.3731 6.39141 4.96993C6.249 6.81754 6.04839 9.81282 6.04839 12C6.04839 14.1872 6.249 17.1825 6.39141 19.0301C6.43741 19.6269 6.90117 20.0977 7.49542 20.1553C8.92753 20.2942 10.9751 20.4615 12.5 20.4615C14.0249 20.4615 16.0725 20.2942 17.5046 20.1553C18.0988 20.0977 18.5626 19.6269 18.6086 19.0301C18.751 17.1825 18.9516 14.1872 18.9516 12C18.9516 11.2947 18.9307 10.5036 18.8975 9.69231H15.5976L15.5968 8.92308L15.5968 8.15385H18.821C18.6302 5.71619 16.728 3.7745 14.3065 3.59594V6.8718C14.3065 7.57985 14.8842 8.15385 15.5968 8.15385L15.5968 8.92308L15.5976 9.69231C14.0298 9.69231 12.7581 8.42952 12.7581 6.8718V3.53997C12.6705 3.53898 12.5844 3.53846 12.5 3.53846ZM13.5569 2.02069C13.1911 2.00756 12.8351 2 12.5 2C10.8935 2 8.78091 2.17427 7.34502 2.31351C5.99709 2.44423 4.95055 3.51605 4.84754 4.85245C4.70508 6.70071 4.5 9.74813 4.5 12C4.5 14.2519 4.70508 17.2993 4.84754 19.1475C4.95055 20.484 5.99709 21.5558 7.34502 21.6865C8.78091 21.8257 10.8935 22 12.5 22C14.1065 22 16.2191 21.8257 17.655 21.6865C19.0029 21.5558 20.0495 20.484 20.1525 19.1475C20.2949 17.2993 20.5 14.2519 20.5 12C20.5 11.0519 20.4637 9.9656 20.4114 8.8902C20.4112 8.88689 20.411 8.88359 20.4109 8.8803C20.3996 8.64894 20.3876 8.41812 20.375 8.1893C20.1948 4.90999 17.6178 2.22743 14.2827 2.05298C14.0417 2.04037 13.8017 2.02954 13.5659 2.02102"
        fill="currentColor"
      />
      <path
        d="M15.5976 9.69231L15.5968 8.92308L15.5968 8.15385M15.5976 9.69231C14.0298 9.69231 12.7581 8.42952 12.7581 6.8718V3.53997C12.6705 3.53898 12.5844 3.53846 12.5 3.53846C10.9751 3.53846 8.92753 3.70582 7.49542 3.8447C6.90117 3.90233 6.43741 4.3731 6.39141 4.96993C6.249 6.81754 6.04839 9.81282 6.04839 12C6.04839 14.1872 6.249 17.1825 6.39141 19.0301C6.43741 19.6269 6.90117 20.0977 7.49542 20.1553C8.92753 20.2942 10.9751 20.4615 12.5 20.4615C14.0249 20.4615 16.0725 20.2942 17.5046 20.1553C18.0988 20.0977 18.5626 19.6269 18.6086 19.0301C18.751 17.1825 18.9516 14.1872 18.9516 12C18.9516 11.2947 18.9307 10.5036 18.8975 9.69231H15.5976ZM15.5968 8.15385C14.8842 8.15385 14.3065 7.57985 14.3065 6.8718V3.59594C16.728 3.7745 18.6302 5.71619 18.821 8.15385H15.5968ZM9.40323 16.359C8.97565 16.359 8.62903 16.7034 8.62903 17.1282C8.62903 17.553 8.97565 17.8974 9.40323 17.8974H13.5323C13.9598 17.8974 14.3065 17.553 14.3065 17.1282C14.3065 16.7034 13.9598 16.359 13.5323 16.359H9.40323ZM9.40323 13.2821C8.97565 13.2821 8.62903 13.6264 8.62903 14.0513C8.62903 14.4761 8.97565 14.8205 9.40323 14.8205H11.4677C11.8953 14.8205 12.2419 14.4761 12.2419 14.0513C12.2419 13.6264 11.8953 13.2821 11.4677 13.2821H9.40323ZM13.5569 2.02069C13.1911 2.00756 12.8351 2 12.5 2C10.8935 2 8.78091 2.17427 7.34502 2.31351C5.99709 2.44423 4.95055 3.51605 4.84754 4.85245C4.70508 6.70071 4.5 9.74813 4.5 12C4.5 14.2519 4.70508 17.2993 4.84754 19.1475C4.95055 20.484 5.99709 21.5558 7.34502 21.6865C8.78091 21.8257 10.8935 22 12.5 22C14.1065 22 16.2191 21.8257 17.655 21.6865C19.0029 21.5558 20.0495 20.484 20.1525 19.1475C20.2949 17.2993 20.5 14.2519 20.5 12C20.5 11.0519 20.4637 9.9656 20.4113 8.8902C20.4112 8.88689 20.411 8.88359 20.4109 8.8803C20.3996 8.64894 20.3876 8.41812 20.375 8.1893C20.1948 4.90999 17.6178 2.22743 14.2827 2.05298C14.0417 2.04037 13.8017 2.02954 13.5659 2.02102L13.5569 2.02069Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_STAR = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.735 8.74351L12.4158 3.76358C12.2522 3.41214 11.7478 3.41214 11.5842 3.76358L9.26501 8.74351C9.1983 8.88675 9.06125 8.98537 8.9031 9.00394L3.40457 9.64965C3.01652 9.69522 2.86068 10.1703 3.14757 10.433L7.21278 14.1565C7.3297 14.2636 7.38205 14.4232 7.35102 14.5779L6.27191 19.9569C6.19575 20.3365 6.60375 20.6301 6.94472 20.4411L11.7763 17.7624C11.9153 17.6853 12.0847 17.6853 12.2237 17.7624L17.0553 20.4411C17.3963 20.6301 17.8042 20.3365 17.7281 19.9569L16.649 14.5779C16.6179 14.4232 16.6703 14.2636 16.7872 14.1565L20.8524 10.433C21.1393 10.1703 20.9835 9.69522 20.5954 9.64965L15.0969 9.00394C14.9388 8.98537 14.8017 8.88674 14.735 8.74351Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_ABOUTUS = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 20C7.5 18.3431 9.73858 17 12.5 17C15.2614 17 17.5 18.3431 17.5 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 14.2495C20.2659 14.7124 21.5 15.7697 21.5 16.9999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 14.2495C4.7341 14.7124 3.5 15.7697 3.5 16.9999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 14C14.1569 14 15.5 12.6569 15.5 11C15.5 9.34315 14.1569 8 12.5 8C10.8431 8 9.5 9.34315 9.5 11C9.5 12.6569 10.8431 14 12.5 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 10.2361C19.1137 9.68679 19.5 8.8885 19.5 8C19.5 6.34315 18.1569 5 16.5 5C15.7316 5 15.0308 5.28885 14.5 5.76389"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 10.2361C5.88625 9.68679 5.5 8.8885 5.5 8C5.5 6.34315 6.84315 5 8.5 5C9.26835 5 9.96924 5.28885 10.5 5.76389"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

//profile
export const ICON_CALENDAR = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 8H20M16 3V5M8 3V5M5 21H19C20.1046 21 21 20.1046 21 19V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V19C3 20.1046 3.89543 21 5 21ZM16 16.5H16.002V16.502H16V16.5ZM12 16.5H12.002V16.502H12V16.5ZM8 16.5H8.002V16.502H8V16.5ZM16 12.5H16.002V12.502H16V12.5ZM12 12.5H12.002V12.502H12V12.5ZM8 12.5H8.002V12.502H8V12.5Z"
        stroke="#7E8393"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_CALENDAR2 = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M4 8.5H20M16 3.5V5.5M8 3.5V5.5M5 21.5H19C20.1046 21.5 21 20.6046 21 19.5V6.5C21 5.39543 20.1046 4.5 19 4.5H5C3.89543 4.5 3 5.39543 3 6.5V19.5C3 20.6046 3.89543 21.5 5 21.5ZM16 17H16.002V17.002H16V17ZM12 17H12.002V17.002H12V17ZM8 17H8.002V17.002H8V17ZM16 13H16.002V13.002H16V13ZM12 13H12.002V13.002H12V13ZM8 13H8.002V13.002H8V13Z"
        stroke="#18488A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

//mian

export const ICON_LOADING = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      >
        <path
          strokedasharray="60"
          strokedashoffset="60"
          strokeOpacity=".3"
          d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
        >
          <animate
            fill="freeze"
            attributeName="stroke-dashoffset"
            dur="1.3s"
            values="60;0"
          />
        </path>
        <path
          stroke-dasharray="15"
          stroke-dashoffset="15"
          d="M12 3C16.9706 3 21 7.02944 21 12"
        >
          <animate
            fill="freeze"
            attributeName="stroke-dashoffset"
            dur="0.3s"
            values="15;0"
          />
          <animateTransform
            attributeName="transform"
            dur="1.5s"
            repeatCount="indefinite"
            type="rotate"
            values="0 12 12;360 12 12"
          />
        </path>
      </g>
    </svg>
  );
};

export const ICON_LOGIN = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="100"
      height="31"
      viewBox="0 0 100 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="31" rx="10" fill="#00A9A0" />
      <path
        d="M31.648 20V10.228H33.496V18.362H37.346V20H31.648ZM41.5981 20.168C41.0754 20.168 40.6041 20.0793 40.1841 19.902C39.7734 19.7247 39.4187 19.468 39.1201 19.132C38.8307 18.796 38.6067 18.3947 38.4481 17.928C38.2894 17.452 38.2101 16.92 38.2101 16.332C38.2101 15.744 38.2894 15.2167 38.4481 14.75C38.6067 14.2833 38.8307 13.8867 39.1201 13.56C39.4187 13.224 39.7734 12.9673 40.1841 12.79C40.6041 12.6127 41.0754 12.524 41.5981 12.524C42.1207 12.524 42.5921 12.6127 43.0121 12.79C43.4321 12.9673 43.7867 13.224 44.0761 13.56C44.3747 13.8867 44.6034 14.2833 44.7621 14.75C44.9207 15.2167 45.0001 15.744 45.0001 16.332C45.0001 16.92 44.9207 17.452 44.7621 17.928C44.6034 18.3947 44.3747 18.796 44.0761 19.132C43.7867 19.468 43.4321 19.7247 43.0121 19.902C42.5921 20.0793 42.1207 20.168 41.5981 20.168ZM41.5981 18.726C42.0741 18.726 42.4474 18.5813 42.7181 18.292C42.9887 18.0027 43.1241 17.578 43.1241 17.018V15.66C43.1241 15.1093 42.9887 14.6893 42.7181 14.4C42.4474 14.1107 42.0741 13.966 41.5981 13.966C41.1314 13.966 40.7627 14.1107 40.4921 14.4C40.2214 14.6893 40.0861 15.1093 40.0861 15.66V17.018C40.0861 17.578 40.2214 18.0027 40.4921 18.292C40.7627 18.5813 41.1314 18.726 41.5981 18.726ZM53.1827 20.616C53.1827 20.9987 53.1127 21.3347 52.9727 21.624C52.8421 21.9227 52.6227 22.17 52.3147 22.366C52.0067 22.562 51.6101 22.7113 51.1247 22.814C50.6394 22.9167 50.0467 22.968 49.3467 22.968C48.7307 22.968 48.2081 22.926 47.7787 22.842C47.3494 22.7673 46.9947 22.6553 46.7147 22.506C46.4441 22.366 46.2481 22.1887 46.1267 21.974C46.0054 21.7593 45.9447 21.5167 45.9447 21.246C45.9447 20.8353 46.0567 20.5133 46.2807 20.28C46.5141 20.056 46.8361 19.9113 47.2467 19.846V19.692C46.9481 19.6173 46.7147 19.4727 46.5467 19.258C46.3881 19.034 46.3087 18.7727 46.3087 18.474C46.3087 18.2873 46.3461 18.124 46.4207 17.984C46.4954 17.8347 46.5934 17.7087 46.7147 17.606C46.8454 17.5033 46.9901 17.4193 47.1487 17.354C47.3074 17.2793 47.4754 17.2233 47.6527 17.186V17.13C47.2047 16.9247 46.8687 16.64 46.6447 16.276C46.4301 15.912 46.3227 15.4873 46.3227 15.002C46.3227 14.2553 46.5794 13.658 47.0927 13.21C47.6061 12.7527 48.3574 12.524 49.3467 12.524C49.5707 12.524 49.7901 12.538 50.0047 12.566C50.2287 12.594 50.4341 12.6407 50.6207 12.706V12.468C50.6207 11.7587 50.9661 11.404 51.6567 11.404H52.7907V12.776H51.2367V12.972C51.6194 13.1867 51.9041 13.4667 52.0907 13.812C52.2774 14.1573 52.3707 14.554 52.3707 15.002C52.3707 15.7393 52.1141 16.332 51.6007 16.78C51.0967 17.228 50.3454 17.452 49.3467 17.452C48.9174 17.452 48.5441 17.41 48.2267 17.326C48.0867 17.3913 47.9654 17.48 47.8627 17.592C47.7601 17.6947 47.7087 17.8253 47.7087 17.984C47.7087 18.348 48.0261 18.53 48.6607 18.53H50.6207C51.5167 18.53 52.1654 18.7167 52.5667 19.09C52.9774 19.454 53.1827 19.9627 53.1827 20.616ZM51.5027 20.826C51.5027 20.5927 51.4094 20.4107 51.2227 20.28C51.0361 20.1493 50.7141 20.084 50.2567 20.084H47.7647C47.5127 20.2707 47.3867 20.5227 47.3867 20.84C47.3867 21.12 47.5034 21.3393 47.7367 21.498C47.9701 21.6567 48.3667 21.736 48.9267 21.736H49.8227C50.4107 21.736 50.8354 21.6613 51.0967 21.512C51.3674 21.3627 51.5027 21.134 51.5027 20.826ZM49.3467 16.234C50.2241 16.234 50.6627 15.8607 50.6627 15.114V14.876C50.6627 14.1293 50.2241 13.756 49.3467 13.756C48.4694 13.756 48.0307 14.1293 48.0307 14.876V15.114C48.0307 15.8607 48.4694 16.234 49.3467 16.234ZM58.4222 11.628C58.0489 11.628 57.7782 11.544 57.6102 11.376C57.4516 11.208 57.3722 10.9933 57.3722 10.732V10.452C57.3722 10.1907 57.4516 9.976 57.6102 9.808C57.7782 9.64 58.0489 9.556 58.4222 9.556C58.7862 9.556 59.0522 9.64 59.2202 9.808C59.3882 9.976 59.4722 10.1907 59.4722 10.452V10.732C59.4722 10.9933 59.3882 11.208 59.2202 11.376C59.0522 11.544 58.7862 11.628 58.4222 11.628ZM57.5262 12.692H59.3182V20H57.5262V12.692ZM61.3954 20V12.692H63.1874V13.91H63.2574C63.4067 13.518 63.64 13.1913 63.9574 12.93C64.284 12.6593 64.732 12.524 65.3014 12.524C66.0574 12.524 66.636 12.7713 67.0374 13.266C67.4387 13.7607 67.6394 14.4653 67.6394 15.38V20H65.8474V15.562C65.8474 15.0393 65.754 14.6473 65.5674 14.386C65.3807 14.1247 65.0727 13.994 64.6434 13.994C64.4567 13.994 64.2747 14.022 64.0974 14.078C63.9294 14.1247 63.7754 14.1993 63.6354 14.302C63.5047 14.3953 63.3974 14.5167 63.3134 14.666C63.2294 14.806 63.1874 14.974 63.1874 15.17V20H61.3954Z"
        fill="white"
      />
    </svg>

    // <svg
    //   onClick={onClick}
    //   className={className}
    //   width="100"
    //   height="31"
    //   viewBox="0 0 100 31"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <rect width="100" height="31" rx="10" fill="#00A9A0" />
    //   <path
    //     d="M33.648 20V10.228H35.496V18.362H39.346V20H33.648ZM43.5981 20.168C43.0754 20.168 42.6041 20.0793 42.1841 19.902C41.7734 19.7247 41.4187 19.468 41.1201 19.132C40.8307 18.796 40.6067 18.3947 40.4481 17.928C40.2894 17.452 40.2101 16.92 40.2101 16.332C40.2101 15.744 40.2894 15.2167 40.4481 14.75C40.6067 14.2833 40.8307 13.8867 41.1201 13.56C41.4187 13.224 41.7734 12.9673 42.1841 12.79C42.6041 12.6127 43.0754 12.524 43.5981 12.524C44.1207 12.524 44.5921 12.6127 45.0121 12.79C45.4321 12.9673 45.7867 13.224 46.0761 13.56C46.3747 13.8867 46.6034 14.2833 46.7621 14.75C46.9207 15.2167 47.0001 15.744 47.0001 16.332C47.0001 16.92 46.9207 17.452 46.7621 17.928C46.6034 18.3947 46.3747 18.796 46.0761 19.132C45.7867 19.468 45.4321 19.7247 45.0121 19.902C44.5921 20.0793 44.1207 20.168 43.5981 20.168ZM43.5981 18.726C44.0741 18.726 44.4474 18.5813 44.7181 18.292C44.9887 18.0027 45.1241 17.578 45.1241 17.018V15.66C45.1241 15.1093 44.9887 14.6893 44.7181 14.4C44.4474 14.1107 44.0741 13.966 43.5981 13.966C43.1314 13.966 42.7627 14.1107 42.4921 14.4C42.2214 14.6893 42.0861 15.1093 42.0861 15.66V17.018C42.0861 17.578 42.2214 18.0027 42.4921 18.292C42.7627 18.5813 43.1314 18.726 43.5981 18.726ZM55.1827 20.616C55.1827 20.9987 55.1127 21.3347 54.9727 21.624C54.8421 21.9227 54.6227 22.17 54.3147 22.366C54.0067 22.562 53.6101 22.7113 53.1247 22.814C52.6394 22.9167 52.0467 22.968 51.3467 22.968C50.7307 22.968 50.2081 22.926 49.7787 22.842C49.3494 22.7673 48.9947 22.6553 48.7147 22.506C48.4441 22.366 48.2481 22.1887 48.1267 21.974C48.0054 21.7593 47.9447 21.5167 47.9447 21.246C47.9447 20.8353 48.0567 20.5133 48.2807 20.28C48.5141 20.056 48.8361 19.9113 49.2467 19.846V19.692C48.9481 19.6173 48.7147 19.4727 48.5467 19.258C48.3881 19.034 48.3087 18.7727 48.3087 18.474C48.3087 18.2873 48.3461 18.124 48.4207 17.984C48.4954 17.8347 48.5934 17.7087 48.7147 17.606C48.8454 17.5033 48.9901 17.4193 49.1487 17.354C49.3074 17.2793 49.4754 17.2233 49.6527 17.186V17.13C49.2047 16.9247 48.8687 16.64 48.6447 16.276C48.4301 15.912 48.3227 15.4873 48.3227 15.002C48.3227 14.2553 48.5794 13.658 49.0927 13.21C49.6061 12.7527 50.3574 12.524 51.3467 12.524C51.5707 12.524 51.7901 12.538 52.0047 12.566C52.2287 12.594 52.4341 12.6407 52.6207 12.706V12.468C52.6207 11.7587 52.9661 11.404 53.6567 11.404H54.7907V12.776H53.2367V12.972C53.6194 13.1867 53.9041 13.4667 54.0907 13.812C54.2774 14.1573 54.3707 14.554 54.3707 15.002C54.3707 15.7393 54.1141 16.332 53.6007 16.78C53.0967 17.228 52.3454 17.452 51.3467 17.452C50.9174 17.452 50.5441 17.41 50.2267 17.326C50.0867 17.3913 49.9654 17.48 49.8627 17.592C49.7601 17.6947 49.7087 17.8253 49.7087 17.984C49.7087 18.348 50.0261 18.53 50.6607 18.53H52.6207C53.5167 18.53 54.1654 18.7167 54.5667 19.09C54.9774 19.454 55.1827 19.9627 55.1827 20.616ZM53.5027 20.826C53.5027 20.5927 53.4094 20.4107 53.2227 20.28C53.0361 20.1493 52.7141 20.084 52.2567 20.084H49.7647C49.5127 20.2707 49.3867 20.5227 49.3867 20.84C49.3867 21.12 49.5034 21.3393 49.7367 21.498C49.9701 21.6567 50.3667 21.736 50.9267 21.736H51.8227C52.4107 21.736 52.8354 21.6613 53.0967 21.512C53.3674 21.3627 53.5027 21.134 53.5027 20.826ZM51.3467 16.234C52.2241 16.234 52.6627 15.8607 52.6627 15.114V14.876C52.6627 14.1293 52.2241 13.756 51.3467 13.756C50.4694 13.756 50.0307 14.1293 50.0307 14.876V15.114C50.0307 15.8607 50.4694 16.234 51.3467 16.234ZM57.1136 11.628C56.7403 11.628 56.4696 11.544 56.3016 11.376C56.143 11.208 56.0636 10.9933 56.0636 10.732V10.452C56.0636 10.1907 56.143 9.976 56.3016 9.808C56.4696 9.64 56.7403 9.556 57.1136 9.556C57.4776 9.556 57.7436 9.64 57.9116 9.808C58.0796 9.976 58.1636 10.1907 58.1636 10.452V10.732C58.1636 10.9933 58.0796 11.208 57.9116 11.376C57.7436 11.544 57.4776 11.628 57.1136 11.628ZM56.2176 12.692H58.0096V20H56.2176V12.692ZM60.0868 20V12.692H61.8788V13.91H61.9488C62.0981 13.518 62.3314 13.1913 62.6488 12.93C62.9754 12.6593 63.4234 12.524 63.9928 12.524C64.7488 12.524 65.3274 12.7713 65.7288 13.266C66.1301 13.7607 66.3308 14.4653 66.3308 15.38V20H64.5388V15.562C64.5388 15.0393 64.4454 14.6473 64.2588 14.386C64.0721 14.1247 63.7641 13.994 63.3348 13.994C63.1481 13.994 62.9661 14.022 62.7888 14.078C62.6208 14.1247 62.4668 14.1993 62.3268 14.302C62.1961 14.3953 62.0888 14.5167 62.0048 14.666C61.9208 14.806 61.8788 14.974 61.8788 15.17V20H60.0868Z"
    //     fill="white"
    //   />
    // </svg>
  );
};

export const ICON_LINK = ({ className, onClick }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.64331 12.3566L12.3574 7.64258"
        stroke="#18488A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.87504 9.41016L4.69653 10.5887C3.39478 11.8904 3.39478 14.001 4.69653 15.3027C5.99827 16.6045 8.10882 16.6045 9.41057 15.3027L10.5891 14.1242"
        stroke="#18488A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.41089 5.87553L10.5894 4.69701C11.8911 3.39527 14.0017 3.39527 15.3034 4.69701C16.6052 5.99876 16.6052 8.10931 15.3034 9.41106L14.1249 10.5896"
        stroke="#18488A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_PROFILE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M7 19.5C7 17.8431 9.23858 16.5 12 16.5C14.7614 16.5 17 17.8431 17 19.5M15 10.5C15 12.1569 13.6569 13.5 12 13.5C10.3431 13.5 9 12.1569 9 10.5C9 8.84315 10.3431 7.5 12 7.5C13.6569 7.5 15 8.84315 15 10.5ZM21 12.5C21 17.4706 16.9706 21.5 12 21.5C7.02944 21.5 3 17.4706 3 12.5C3 7.52944 7.02944 3.5 12 3.5C16.9706 3.5 21 7.52944 21 12.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_ASK = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M12 21.5C16.9706 21.5 21 17.4706 21 12.5C21 7.52944 16.9706 3.5 12 3.5C7.02944 3.5 3 7.52944 3 12.5C3 17.4706 7.02944 21.5 12 21.5Z"
        stroke="#14181F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5Z"
        fill="#14181F"
      />
      <path
        d="M10.5858 8.61416C10.9754 8.22454 11.4858 8.02928 11.9965 8.02838C12.5095 8.02748 13.0228 8.22274 13.4142 8.61416C13.8047 9.00469 14 9.51654 14 10.0284C14 10.5402 13.8047 11.0521 13.4142 11.4426C13.0228 11.834 12.5095 12.0293 11.9965 12.0284L12 13.0284"
        stroke="#14181F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_WORK_WITH_US = ({ className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint0_radial_4639_23149)"
      />
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint1_radial_4639_23149)"
      />
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint2_radial_4639_23149)"
      />
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint3_radial_4639_23149)"
        fill-opacity="0.6"
      />
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint4_radial_4639_23149)"
      />
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint5_radial_4639_23149)"
      />
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint6_radial_4639_23149)"
      />
      <path
        d="M12.9991 25.2482C21.1664 25.2482 25.2482 19.7638 25.2482 12.9983C25.2482 6.2345 21.1664 0.75 12.9983 0.75C4.83187 0.75 0.75 6.2345 0.75 12.9991C0.75 19.7637 4.831 25.2482 12.9991 25.2482Z"
        fill="url(#paint7_radial_4639_23149)"
      />
      <g filter="url(#filter0_f_4639_23149)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.49562 11.7987C10.0628 11.3461 10.4753 10.7284 10.676 10.0311C10.8767 9.33377 10.8557 8.59132 10.6159 7.90646C10.3761 7.2216 9.92943 6.6282 9.33761 6.20836C8.74579 5.78851 8.03812 5.56299 7.3125 5.56299C6.58688 5.56299 5.87921 5.78851 5.28739 6.20836C4.69557 6.6282 4.24887 7.2216 4.0091 7.90646C3.76933 8.59132 3.74835 9.33377 3.94905 10.0311C4.14975 10.7284 4.56222 11.3461 5.12938 11.7987C5.75413 11.5887 6.553 11.3962 7.3125 11.3962C8.072 11.3962 8.87 11.5887 9.49562 11.7987Z"
          fill="#B3671F"
        />
      </g>
      <g filter="url(#filter1_f_4639_23149)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.5581 11.5799C20.1253 11.1273 20.5378 10.5096 20.7385 9.81232C20.9392 9.11502 20.9182 8.37257 20.6784 7.68771C20.4386 7.00285 19.9919 6.40945 19.4001 5.98961C18.8083 5.56976 18.1006 5.34424 17.375 5.34424C16.6494 5.34424 15.9417 5.56976 15.3499 5.98961C14.7581 6.40945 14.3114 7.00285 14.0716 7.68771C13.8318 8.37257 13.8108 9.11502 14.0115 9.81232C14.2122 10.5096 14.6247 11.1273 15.1919 11.5799C15.8166 11.3699 16.6155 11.1774 17.375 11.1774C18.1345 11.1774 18.9325 11.3699 19.5581 11.5799Z"
          fill="#9F5915"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.125 8.18751C12.1255 8.77907 11.9925 9.36311 11.7358 9.8961C11.4792 10.4291 11.1055 10.8973 10.6428 11.2658C9.94013 11.0295 9.0415 10.8125 8.1875 10.8125C7.33263 10.8125 6.43488 11.0295 5.73225 11.2658C5.21142 10.8503 4.80452 10.3096 4.54961 9.69405C4.29471 9.07853 4.20015 8.40841 4.27479 7.74639C4.34942 7.08438 4.59081 6.45212 4.97635 5.90881C5.3619 5.3655 5.87899 4.92889 6.47924 4.63986C7.07948 4.35083 7.74325 4.21883 8.40841 4.2562C9.07356 4.29358 9.71836 4.49911 10.2825 4.85357C10.8465 5.20803 11.3115 5.69981 11.6337 6.2829C11.956 6.86598 12.125 7.5213 12.125 8.18751ZM21.75 8.18751C21.7505 8.77907 21.6175 9.36311 21.3608 9.8961C21.1042 10.4291 20.7305 10.8973 20.2678 11.2658C19.5651 11.0295 18.6665 10.8125 17.8125 10.8125C16.9576 10.8125 16.0599 11.0295 15.3573 11.2658C14.8364 10.8503 14.4295 10.3096 14.1746 9.69405C13.9197 9.07853 13.8252 8.40841 13.8998 7.74639C13.9744 7.08438 14.2158 6.45212 14.6014 5.90881C14.9869 5.3655 15.504 4.92889 16.1042 4.63986C16.7045 4.35083 17.3682 4.21883 18.0334 4.2562C18.6986 4.29358 19.3434 4.49911 19.9075 4.85357C20.4715 5.20803 20.9365 5.69981 21.2587 6.2829C21.581 6.86598 21.75 7.5213 21.75 8.18751Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.25 8.1875C11.25 9.44225 10.6025 10.5211 9.67675 10.9945C9.18844 10.8798 8.68906 10.8187 8.1875 10.8125C7.91363 10.8125 7.63625 10.8344 7.3615 10.8729C6.55125 10.3523 6 9.34425 6 8.1875C6 6.49613 7.17513 5.125 8.625 5.125C10.0749 5.125 11.25 6.49613 11.25 8.1875ZM20 8.1875C20 9.34425 19.4496 10.3523 18.6385 10.8729C18.3649 10.8339 18.0889 10.8137 17.8125 10.8125C17.3146 10.8125 16.8028 10.886 16.3233 10.9945C15.3966 10.5211 14.75 9.44225 14.75 8.1875C14.75 6.49613 15.9251 5.125 17.375 5.125C18.8249 5.125 20 6.49613 20 8.1875Z"
        fill="url(#paint8_linear_4639_23149)"
      />
      <path
        d="M13 20.875C5.125 20.875 5.125 13 5.125 13H20.875C20.875 13 20.875 20.875 13 20.875Z"
        fill="url(#paint9_radial_4639_23149)"
      />
      <path
        d="M6 13.4375V13H20V13.4375C20 13.6696 19.9078 13.8921 19.7437 14.0562C19.5796 14.2203 19.3571 14.3125 19.125 14.3125H6.875C6.64294 14.3125 6.42038 14.2203 6.25628 14.0562C6.09219 13.8921 6 13.6696 6 13.4375Z"
        fill="url(#paint10_linear_4639_23149)"
      />
      <defs>
        <filter
          id="filter0_f_4639_23149"
          x="1.8125"
          y="3.56299"
          width="11"
          height="10.2357"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_4639_23149"
          />
        </filter>
        <filter
          id="filter1_f_4639_23149"
          x="11.875"
          y="3.34424"
          width="11"
          height="10.2357"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_4639_23149"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.3127 6.87463) rotate(132.839) scale(32.8154)"
        >
          <stop stop-color="#FFF478" />
          <stop offset="0.475" stop-color="#FFB02E" />
          <stop offset="1" stop-color="#F70A8D" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.3115 6.87556) rotate(131.878) scale(34.0801)"
        >
          <stop stop-color="#FFF478" />
          <stop offset="0.475" stop-color="#FFB02E" />
          <stop offset="1" stop-color="#F70A8D" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.9994 9.93726) rotate(101.31) scale(15.6158 20.0008)"
        >
          <stop offset="0.788" stop-color="#F59639" stop-opacity="0" />
          <stop offset="0.973" stop-color="#FF7DCE" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.75 11.25) rotate(135) scale(35.8857)"
        >
          <stop offset="0.315" stop-opacity="0" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13 13.8757) rotate(77.692) scale(24.6285)"
        >
          <stop offset="0.508" stop-color="#7D6133" stop-opacity="0" />
          <stop offset="1" stop-color="#715B32" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.4375 13.4375) rotate(55.713) scale(11.6493 8.44403)"
        >
          <stop stop-color="#FFB849" />
          <stop offset="1" stop-color="#FFB847" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.9375 14.75) rotate(9.86582) scale(10.2135)"
        >
          <stop stop-color="#FFA64B" />
          <stop offset="0.9" stop-color="#FFAE46" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.3125 12.1252) rotate(43.971) scale(51.6713)"
        >
          <stop offset="0.185" stop-opacity="0" />
          <stop offset="1" stop-opacity="0.4" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_4639_23149"
          x1="18.3848"
          y1="5.125"
          x2="17.1335"
          y2="10.942"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#553B3E" />
          <stop offset="1" stop-color="#3D2432" />
        </linearGradient>
        <radialGradient
          id="paint9_radial_4639_23149"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13 22.625) rotate(-90) scale(9.625 19.25)"
        >
          <stop stop-color="#F70A8D" />
          <stop offset="1" stop-color="#89029C" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_4639_23149"
          x1="13"
          y1="13"
          x2="13"
          y2="14.3125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#ECCDFF" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ICON_UPLOAD = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M12.25 9.25V11.5833C12.25 11.8928 12.1271 12.1895 11.9083 12.4083C11.6895 12.6271 11.3928 12.75 11.0833 12.75H2.91667C2.60725 12.75 2.3105 12.6271 2.09171 12.4083C1.87292 12.1895 1.75 11.8928 1.75 11.5833V9.25M9.91667 5.16667L7 2.25M7 2.25L4.08333 5.16667M7 2.25V9.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};

export const ICON_HAMBURGER = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 25 35"
      fill="none"
    >
      <path
        d="M3.125 24.7916H21.875"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 17.5H21.875"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 10.2084H21.875"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_INFO = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M7.5 2.03125C4.47969 2.03125 2.03125 4.47969 2.03125 7.5C2.03125 10.5203 4.47969 12.9688 7.5 12.9688C10.5203 12.9688 12.9688 10.5203 12.9688 7.5C12.9688 4.47969 10.5203 2.03125 7.5 2.03125ZM1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5ZM7.5 6.25C7.71563 6.25 7.89063 6.425 7.89063 6.64063V10.5469C7.89063 10.6505 7.84947 10.7498 7.77621 10.8231C7.70296 10.8963 7.6036 10.9375 7.5 10.9375C7.3964 10.9375 7.29704 10.8963 7.22379 10.8231C7.15053 10.7498 7.10938 10.6505 7.10938 10.5469V6.64063C7.10938 6.425 7.28438 6.25 7.5 6.25ZM7.5 5.3125C7.66576 5.3125 7.82473 5.24665 7.94194 5.12944C8.05915 5.01223 8.125 4.85326 8.125 4.6875C8.125 4.52174 8.05915 4.36277 7.94194 4.24556C7.82473 4.12835 7.66576 4.0625 7.5 4.0625C7.33424 4.0625 7.17527 4.12835 7.05806 4.24556C6.94085 4.36277 6.875 4.52174 6.875 4.6875C6.875 4.85326 6.94085 5.01223 7.05806 5.12944C7.17527 5.24665 7.33424 5.3125 7.5 5.3125Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export const ICON_CHECK = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 10L11 14L9 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_WARNING = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.5259 18.5L12.8657 3.5C12.4808 2.83333 11.5185 2.83333 11.1336 3.5L2.47336 18.5C2.08846 19.1667 2.56958 20 3.33938 20H20.6599C21.4297 20 21.9108 19.1667 21.5259 18.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeWnecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 15.9999C13.5 16.8284 12.8284 17.4999 12 17.4999C11.1716 17.4999 10.5 16.8284 10.5 15.9999C10.5 15.1715 11.1716 14.4999 12 14.4999C12.8284 14.4999 13.5 15.1715 13.5 15.9999Z"
        fill="currentColor"
      />
      <path
        d="M12 12L12 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeWnecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_WARNING_CIRCLE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M12.1 12.5C12.1 12.7209 12.2791 12.9 12.5 12.9C12.7209 12.9 12.9 12.7209 12.9 12.5H12.1ZM12.9 8.33333C12.9 8.11242 12.7209 7.93333 12.5 7.93333C12.2791 7.93333 12.1 8.11242 12.1 8.33333H12.9ZM21.475 12.5C21.475 17.4568 17.4568 21.475 12.5 21.475V22.275C17.8986 22.275 22.275 17.8986 22.275 12.5H21.475ZM12.5 21.475C7.54324 21.475 3.525 17.4568 3.525 12.5H2.725C2.725 17.8986 7.10142 22.275 12.5 22.275V21.475ZM3.525 12.5C3.525 7.54324 7.54324 3.525 12.5 3.525V2.725C7.10142 2.725 2.725 7.10142 2.725 12.5H3.525ZM12.5 3.525C17.4568 3.525 21.475 7.54324 21.475 12.5H22.275C22.275 7.10142 17.8986 2.725 12.5 2.725V3.525ZM13.6625 16.6666C13.6625 17.3086 13.142 17.8291 12.5 17.8291V18.6291C13.5839 18.6291 14.4625 17.7505 14.4625 16.6666H13.6625ZM12.5 17.8291C11.858 17.8291 11.3375 17.3086 11.3375 16.6666H10.5375C10.5375 17.7505 11.4161 18.6291 12.5 18.6291V17.8291ZM11.3375 16.6666C11.3375 16.0246 11.858 15.5041 12.5 15.5041V14.7041C11.4161 14.7041 10.5375 15.5827 10.5375 16.6666H11.3375ZM12.5 15.5041C13.142 15.5041 13.6625 16.0246 13.6625 16.6666H14.4625C14.4625 15.5827 13.5839 14.7041 12.5 14.7041V15.5041ZM12.9 12.5V8.33333H12.1V12.5H12.9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ICON_CLOSE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={cn("!text-red-500", className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 9L9 15M9 9L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_RLOCNG_RIGHT = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 36 8"
      fill="none"
    >
      <path
        d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64645L32.1716 0.464466C31.9763 0.269204 31.6597 0.269204 31.4645 0.464466C31.2692 0.659728 31.2692 0.976311 31.4645 1.17157L34.2929 4L31.4645 6.82843C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.7308 31.9763 7.7308 32.1716 7.53553L35.3536 4.35355ZM0 4.5L35 4.5V3.5L0 3.5L0 4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ICON_CIRCLE_RIGHT = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7L15 12L10 17M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_PLUS = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 12H12M12 12H16M12 12V16M12 12V8M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_CLOSE_NO_CIIRCLE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 21L3 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0001 3L3 21.0001"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_NAVIGATE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} cursor-pointer`}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 12L3 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17L3 12L8 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_NAVIGATE_RIGHT = ({ className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 19L19 12L12 5M19 12L5 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_NAVIGATE_BALANCE = ({
  className = "w-6 h-6 cursor-pointer",
  onClick,
}) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 12L21 12"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17L21 12L16 7"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_GRAPH = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 17L12.6154 9.5L9.53846 12.625L4 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 11V17H14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_BAHT = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 15 24"
      fill="none"
    >
      <path
        d="M6.75 0C5.92031 0 5.25 0.670312 5.25 1.5V3H1.7625C0.7875 3 0 3.7875 0 4.7625V19.0453C0 20.1234 0.876563 21 1.95469 21H5.25V22.5C5.25 23.3297 5.92031 24 6.75 24C7.57969 24 8.25 23.3297 8.25 22.5V21H9.75C12.6516 21 15 18.6516 15 15.75C15 13.8703 14.0109 12.2203 12.5297 11.2922C13.1391 10.4344 13.5 9.38437 13.5 8.25C13.5 5.34844 11.1516 3 8.25 3V1.5C8.25 0.670312 7.57969 0 6.75 0ZM5.25 6V10.5H3V6H5.25ZM8.25 10.5V6C9.49219 6 10.5 7.00781 10.5 8.25C10.5 9.49219 9.49219 10.5 8.25 10.5ZM5.25 13.5V18H3V13.5H5.25ZM8.25 18V13.5H9.75C10.9922 13.5 12 14.5078 12 15.75C12 16.9922 10.9922 18 9.75 18H8.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ICON_MINUS_CIRCLE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      // width="14"
      // height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M4.66666 7.5H9.33332M12.25 7.5C12.25 10.3995 9.89949 12.75 7 12.75C4.1005 12.75 1.75 10.3995 1.75 7.5C1.75 4.6005 4.1005 2.25 7 2.25C9.89949 2.25 12.25 4.6005 12.25 7.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_DELETE = ({
  className = " md:w-4 md:h-4  w-4 h-4 flex-none cursor-pointer",
  onClick,
}) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.57143 7V4.8C8.57143 4.32261 8.75204 3.86477 9.07353 3.52721C9.39502 3.18964 9.83106 3 10.2857 3H13.7143C14.1689 3 14.605 3.18964 14.9265 3.52721C15.248 3.86477 15.4286 4.32261 15.4286 4.8V7M4 7H20M10 11V16M14 11V16M19 7L18 19.2C18 19.6774 17.8194 20.1352 17.4979 20.4728C17.1764 20.8104 16.7404 21 16.2857 21H7.71429C7.25963 21 6.82359 20.8104 6.5021 20.4728C6.18061 20.1352 6 19.6774 6 19.2L5 7H19Z"
        stroke="#AA1616 "
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ICON_EDIT_PENCIL = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M7.00065 12.1667H11.6673M9.39456 3.22332C9.51818 3.09969 9.66495 3.00162 9.82648 2.93472C9.98801 2.86781 10.1611 2.83337 10.336 2.83337C10.5108 2.83337 10.6839 2.86781 10.8455 2.93472C11.007 3.00162 11.1537 3.09969 11.2774 3.22332C11.401 3.34695 11.4991 3.49371 11.566 3.65524C11.6329 3.81677 11.6673 3.98989 11.6673 4.16473C11.6673 4.33956 11.6329 4.51269 11.566 4.67422C11.4991 4.83574 11.401 4.98251 11.2774 5.10614L4.92286 11.4607L2.33398 12.1667L3.04004 9.57783L9.39456 3.22332Z"
        stroke="#909090"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_EDIT_PROFILE = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M8.75 4.25H4.08333C3.72971 4.25 3.39057 4.39048 3.14052 4.64052C2.89048 4.89057 2.75 5.22971 2.75 5.58333V14.9167C2.75 15.2703 2.89048 15.6094 3.14052 15.8595C3.39057 16.1095 3.72971 16.25 4.08333 16.25H13.4167C13.7703 16.25 14.1094 16.1095 14.3595 15.8595C14.6095 15.6094 14.75 15.2703 14.75 14.9167V10.25M13.7497 3.17899C14.0244 2.90431 14.3969 2.75 14.7853 2.75C15.1738 2.75 15.5463 2.90431 15.821 3.17899C16.0957 3.45366 16.25 3.8262 16.25 4.21466C16.25 4.60311 16.0957 4.97565 15.821 5.25032L9.26178 11.8096L6.5 12.5L7.19045 9.73822L13.7497 3.17899Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_EDIT = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46186 1.69875C10.1709 0.989739 11.3204 0.989741 12.0294 1.69875L12.8029 2.47222C13.5119 3.18123 13.5119 4.33076 12.8029 5.03977L5.54074 12.3019C5.20026 12.6424 4.73848 12.8337 4.25697 12.8337H2.16311C1.88965 12.8337 1.66797 12.612 1.66797 12.3385V10.2447C1.66797 9.76315 1.85925 9.30136 2.19973 8.96088L9.46186 1.69875ZM11.3292 2.39899C11.0069 2.07671 10.4844 2.07671 10.1621 2.39899L8.8051 3.75599L10.7456 5.69653L12.1026 4.33953C12.4249 4.01725 12.4249 3.49473 12.1026 3.17246L11.3292 2.39899ZM10.0454 6.39677L8.10486 4.45623L2.89997 9.66113C2.7452 9.81589 2.65826 10.0258 2.65826 10.2447V11.8434H4.25697C4.47584 11.8434 4.68574 11.7564 4.8405 11.6017L10.0454 6.39677Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ICON_RIGHT_2 = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 12H21M21 12L16 7M21 12L16 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_RIGHT = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M9 5.5L16 12.5L9 19.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_LOGOUT = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 4H7C5.89543 4 5 4.89543 5 6V18C5 19.1046 5.89543 20 7 20H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 15L19 12M19 12L16 9M19 12H9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_DL_PDF = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M12.5 12V14H4.5V12H3.5V14C3.5 14.2652 3.60536 14.5196 3.79289 14.7071C3.98043 14.8946 4.23478 15 4.5 15H12.5C12.7652 15 13.0196 14.8946 13.2071 14.7071C13.3946 14.5196 13.5 14.2652 13.5 14V12H12.5Z"
        fill="currentColor"
      />
      <path
        d="M11 10.5L10.293 9.793L9 11.086V7H8V11.086L6.707 9.793L6 10.5L8.5 13L11 10.5ZM14.5 2V1H11.5V6H12.5V4H14V3H12.5V2H14.5ZM9 6H7V1H9C9.3977 1.0004 9.779 1.15856 10.0602 1.43978C10.3414 1.721 10.4996 2.1023 10.5 2.5V4.5C10.4996 4.8977 10.3414 5.279 10.0602 5.56022C9.779 5.84144 9.3977 5.9996 9 6ZM8 5H9C9.13257 4.99987 9.25967 4.94715 9.35341 4.85341C9.44715 4.75967 9.49987 4.63257 9.5 4.5V2.5C9.49987 2.36743 9.44715 2.24033 9.35341 2.14659C9.25967 2.05285 9.13257 2.00013 9 2H8V5ZM5 1H2.5V6H3.5V4.5H5C5.26509 4.4996 5.51922 4.39412 5.70667 4.20667C5.89412 4.01922 5.9996 3.76509 6 3.5V2C5.99974 1.73486 5.89429 1.48066 5.70681 1.29319C5.51934 1.10571 5.26514 1.00026 5 1ZM3.5 3.5V2H5L5.0005 3.5H3.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ICON_EYE = ({ className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.7 12C14.7 13.4912 13.4912 14.7 12 14.7C10.5088 14.7 9.3 13.4912 9.3 12C9.3 10.5088 10.5088 9.3 12 9.3C13.4912 9.3 14.7 10.5088 14.7 12Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12C4.44012 8.31238 7.80243 5.7 12 5.7C16.1976 5.7 19.5599 8.31238 21 12C19.5599 15.6876 16.1976 18.3 12 18.3C7.80243 18.3 4.44012 15.6876 3 12Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ICON_EYE_CLOSE = ({ className, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 4L20 20"
        stroke="#14181F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8572 5.76587C11.2304 5.72236 11.6116 5.7 12 5.7C16.1976 5.7 19.5599 8.31238 21 12C20.6449 12.9094 20.1728 13.7533 19.6002 14.5089M7.06766 7.06749C5.23159 8.18765 3.811 9.92332 3 12C4.44012 15.6876 7.80243 18.3 12 18.3C13.8338 18.3 15.5082 17.8014 16.9325 16.9324M10.0909 10.0907C9.60224 10.5793 9.3 11.2544 9.3 12C9.3 13.4912 10.5088 14.7 12 14.7C12.7456 14.7 13.4207 14.3978 13.9093 13.9091"
        stroke="#14181F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.80005 4.8L19.2 19.2"
        stroke="#14181F"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ICON_ARROW_UP_DOWN = ({
  className,
  onClick,
  color = "#919191",
}) => {
  return (
    // <svg
    //   className={className}
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 17 16"
    //   fill="none"
    //   rotate={180}
    // >
    //   <path
    //     d="M3.83366 10L8.50033 5.33336L13.167 10"
    //     stroke="#919191"
    //     strokeWidth="2"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      // width="24"
      // height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 9.46967C18.8232 9.76256 18.8232 10.2374 18.5303 10.5303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L5.46967 10.5303C5.17678 10.2374 5.17678 9.76256 5.46967 9.46967C5.76256 9.17678 6.23744 9.17678 6.53033 9.46967L12 14.9393L17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967Z"
        fill={color}
      />
    </svg>
  );
};

export const ICON_TAIL_ARROW_RIGHT = ({ className, onClick }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M12 19L19 12L12 5M19 12L5 12"
        stroke="#18488A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ICON_USER = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.625 23.125C6.625 20.8468 9.70304 19 13.5 19C17.297 19 20.375 20.8468 20.375 23.125M17.625 10.75C17.625 13.0282 15.7782 14.875 13.5 14.875C11.2218 14.875 9.375 13.0282 9.375 10.75C9.375 8.47183 11.2218 6.625 13.5 6.625C15.7782 6.625 17.625 8.47183 17.625 10.75ZM25.875 13.5C25.875 20.3345 20.3345 25.875 13.5 25.875C6.66548 25.875 1.125 20.3345 1.125 13.5C1.125 6.66548 6.66548 1.125 13.5 1.125C20.3345 1.125 25.875 6.66548 25.875 13.5Z"
        stroke="currentColor"
        strokeWidth="2"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LOGO_GOOGLE = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1654 12.9703H27.125V12.9167H15.5V18.0833H22.7998C21.7349 21.091 18.8732 23.25 15.5 23.25C11.22 23.25 7.74998 19.7799 7.74998 15.5C7.74998 11.2201 11.22 7.74999 15.5 7.74999C17.4756 7.74999 19.2729 8.49529 20.6415 9.71268L24.2949 6.0592C21.988 3.90922 18.9022 2.58333 15.5 2.58333C8.36675 2.58333 2.58331 8.36677 2.58331 15.5C2.58331 22.6332 8.36675 28.4167 15.5 28.4167C22.6332 28.4167 28.4166 22.6332 28.4166 15.5C28.4166 14.6339 28.3275 13.7885 28.1654 12.9703Z"
        fill="#FFC107"
      />
      <path
        d="M4.07263 9.48793L8.3164 12.6002C9.46469 9.75724 12.2457 7.74999 15.5 7.74999C17.4756 7.74999 19.273 8.49529 20.6415 9.71268L24.295 6.0592C21.988 3.90922 18.9023 2.58333 15.5 2.58333C10.5387 2.58333 6.23617 5.38431 4.07263 9.48793Z"
        fill="#FF3D00"
      />
      <path
        d="M15.5 28.4167C18.8364 28.4167 21.8679 27.1399 24.16 25.0635L20.1622 21.6806C18.8218 22.7 17.184 23.2513 15.5 23.25C12.1404 23.25 9.28771 21.1078 8.21304 18.1182L4.00092 21.3635C6.13862 25.5466 10.4799 28.4167 15.5 28.4167Z"
        fill="#4CAF50"
      />
      <path
        d="M28.1654 12.9703H27.125V12.9167H15.5V18.0833H22.7999C22.2904 19.5148 21.3728 20.7656 20.1603 21.6813L20.1623 21.68L24.16 25.0629C23.8771 25.3199 28.4167 21.9583 28.4167 15.5C28.4167 14.6339 28.3275 13.7885 28.1654 12.9703Z"
        fill="#1976D2"
      />
    </svg>
  );
};

export const LOGO_FACEBOOK = ({ className, onClick }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 14C28 6.26806 21.7319 0 14 0C6.26806 0 0 6.26795 0 14C0 20.9877 5.11962 26.7797 11.8125 27.8299V18.0469H8.25781V14H11.8125V10.9156C11.8125 7.40687 13.9027 5.46875 17.1005 5.46875C18.6323 5.46875 20.2344 5.74219 20.2344 5.74219V9.1875H18.4691C16.7298 9.1875 16.1875 10.2667 16.1875 11.3739V14H20.0703L19.4496 18.0469H16.1875V27.8299C22.8804 26.7797 28 20.9879 28 14Z"
        fill="#1877F2"
      />
      <path
        d="M19.4496 18.0469L20.0703 14H16.1875V11.3739C16.1875 10.2666 16.7299 9.1875 18.4691 9.1875H20.2344V5.74219C20.2344 5.74219 18.6323 5.46875 17.1005 5.46875C13.9027 5.46875 11.8125 7.40688 11.8125 10.9156V14H8.25781V18.0469H11.8125V27.8299C12.5361 27.9433 13.2675 28.0002 14 28C14.7325 28.0002 15.4639 27.9434 16.1875 27.8299V18.0469H19.4496Z"
        fill="white"
      />
    </svg>
  );
};

export const ICON_ADD = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66667 9H9M9 9H12.3333M9 9V12.3333M9 9V5.66667M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#00A9A0"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
//STG

export const ICON_CONTRACT = ({ classNames = "" }) => {
  return (
    <svg
      height="480pt"
      viewBox="0 0 480.08177 480"
      width="480pt"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
    >
      {/* stroke="#8D32E8" fill="#8D32E8" */}
      <path d="m479.199219 113.800781c-1.652344-6.144531-5.683594-11.382812-11.199219-14.558593-5.519531-3.191407-12.082031-4.054688-18.238281-2.402344-6.148438 1.65625-11.386719 5.683594-14.5625 11.199218l-4 6.960938c-3.800781-2.183594-8.65625-.898438-10.878907 2.882812l-20.320312 34.636719-6.960938-4c-1.84375-1.066406-4.039062-1.355469-6.09375-.800781-2.058593.558594-3.808593 1.910156-4.867187 3.761719-2.167969 3.824219-.847656 8.683593 2.960937 10.878906l6.960938 4-68 117.839844-16.800781 44.882812-8 14.957031c-4.683594 8.148438-4.183594 18.277344 1.28125 25.921876l-18 22.078124-5.039063-12.636718c-2.273437-5.632813-7.535156-9.492188-13.585937-9.964844-6.054688-.476562-11.855469 2.515625-14.976563 7.722656l-2.878906 4.878906-2.71875-32c-.625-7.570312-6.488281-13.65625-14.027344-14.570312-7.542968-.910156-14.683594 3.609375-17.09375 10.8125l-19.679687 59.039062c-1.375 4.175782.875 8.675782 5.039062 10.082032.78125.363281 1.621094.582031 2.480469.636718 3.4375.011719 6.5-2.179687 7.601562-5.4375l19.597657-59.039062 2.800781 32.476562c.578125 6.929688 5.558594 12.691407 12.332031 14.261719 6.773438 1.570313 13.78125-1.414062 17.347657-7.378906l2.960937-4.882813 4.960937 12.5625c2.105469 5.292969 6.867188 9.070313 12.503907 9.910157 5.636719.839843 11.292969-1.382813 14.855469-5.832031l18.640624-23.597657c2.0625.539063 4.1875.808594 6.320313.800781 8.574219.066407 16.535156-4.449218 20.878906-11.84375l8-13.359374 30.480469-37.039063 68.71875-119.28125 6.960938 4c1.855468 1.0625 3.207031 2.816406 3.757812 4.882813.554688 2.050781.265625 4.238281-.796875 6.078124l-32 55.441407c-1.207031 1.820312-1.617187 4.054687-1.132813 6.1875.484376 2.128906 1.816407 3.96875 3.691407 5.089843 1.84375 1.070313 4.039062 1.359376 6.09375.804688 2.058593-.558594 3.808593-1.910156 4.867187-3.761719l32-55.441406c3.191406-5.519531 4.054688-12.082031 2.398438-18.238281-1.65625-6.148438-5.683594-11.386719-11.199219-14.5625l-6.960937-4 20-34.640625c2.183593-3.800781.898437-8.652344-2.878907-10.878907l4-6.960937c3.277344-5.605469 4.144531-12.300781 2.398438-18.558594zm-30.160157 2.238281c1.058594-1.851562 2.816407-3.207031 4.882813-3.757812 2.054687-.507812 4.226563-.222656 6.078125.800781 1.855469 1.058594 3.207031 2.816407 3.761719 4.878907.507812 2.054687.222656 4.226562-.800781 6.078124l-4 6.960938-13.921876-8zm-109.039062 223.363282-4-2.320313-11.839844-6.882812 11.359375-30.398438 25.199219 14.558594zm-24 23.117187c-3.378906-2.355469-4.417969-6.886719-2.398438-10.480469l4-6.957031 13.917969 8-4 6.878907c-1.121093 1.945312-3.003906 3.328124-5.195312 3.816406-2.191407.484375-4.484375.03125-6.324219-1.257813zm53.839844-61.277343-27.679688-16 64-110.882813 27.679688 16zm72-124.722657-27.679688-16 16-27.679687 27.679688 16zm0 0" />
      <path d="m126.238281 358.519531-28.316406 28.242188-16.960937-16.960938c-3.121094-3.101562-8.160157-3.101562-11.28125 0-1.515626 1.503907-2.367188 3.546875-2.367188 5.679688 0 2.132812.851562 4.179687 2.367188 5.679687l16.960937 16.960938c3 2.976562 7.054687 4.644531 11.28125 4.640625 4.25.023437 8.339844-1.644531 11.359375-4.640625l28.238281-28.320313c2.71875-3.175781 2.535157-7.90625-.417969-10.859375-2.957031-2.957031-7.6875-3.140625-10.863281-.421875zm0 0" />
      <path d="m32 380.039062c0 37.558594 30.445312 68 68 68s68-30.441406 68-68c0-4.417968-3.582031-8-8-8s-8 3.582032-8 8c0 28.71875-23.28125 52-52 52s-52-23.28125-52-52 23.28125-52 52-52c11.257812-.03125 22.214844 3.621094 31.199219 10.402344 3.535156 2.652344 8.550781 1.933594 11.199219-1.601562 2.652343-3.535156 1.9375-8.546875-1.597657-11.199219-20.605469-15.453125-48.175781-17.9375-71.210937-6.421875-23.039063 11.519531-37.589844 35.066406-37.589844 60.820312zm0 0" />
      <path d="m288 64.039062c4.417969 0 8-3.578124 8-8 0-4.417968-3.582031-8-8-8h-208c-4.417969 0-8 3.582032-8 8v32c0 4.421876 3.582031 8 8 8h208c4.417969 0 8-3.578124 8-8 0-4.417968-3.582031-8-8-8h-200v-16zm0 0" />
      <path d="m104 112.039062c-4.417969 0-8 3.582032-8 8 0 4.421876 3.582031 8 8 8h160c4.417969 0 8-3.578124 8-8 0-4.417968-3.582031-8-8-8zm0 0" />
      <path d="m312 168.039062h-176c-4.417969 0-8 3.582032-8 8 0 4.421876 3.582031 8 8 8h176c4.417969 0 8-3.578124 8-8 0-4.417968-3.582031-8-8-8zm0 0" />
      <path d="m232 224.039062c0-4.417968-3.582031-8-8-8h-160c-4.417969 0-8 3.582032-8 8 0 4.421876 3.582031 8 8 8h160c4.417969 0 8-3.578124 8-8zm0 0" />
      <path d="m312 216.039062h-56c-4.417969 0-8 3.582032-8 8 0 4.421876 3.582031 8 8 8h56c4.417969 0 8-3.578124 8-8 0-4.417968-3.582031-8-8-8zm0 0" />
      <path d="m144 272.039062c4.417969 0 8-3.578124 8-8 0-4.417968-3.582031-8-8-8h-80c-4.417969 0-8 3.582032-8 8 0 4.421876 3.582031 8 8 8zm0 0" />
      <path d="m176 272.039062h56c4.417969 0 8-3.578124 8-8 0-4.417968-3.582031-8-8-8h-56c-4.417969 0-8 3.582032-8 8 0 4.421876 3.582031 8 8 8zm0 0" />
      <path d="m360 368.039062c-4.417969 0-8 3.582032-8 8v80c0 4.421876-3.582031 8-8 8h-320c-4.417969 0-8-3.578124-8-8v-432c0-4.417968 3.582031-8 8-8h320c4.417969 0 8 3.582032 8 8v150.242188c0 4.417969 3.582031 8 8 8s8-3.582031 8-8v-150.242188c0-13.253906-10.746094-23.9999995-24-23.9999995h-320c-13.253906 0-24 10.7460935-24 23.9999995v432c0 13.257813 10.746094 24 24 24h320c13.253906 0 24-10.742187 24-24v-80c0-4.417968-3.582031-8-8-8zm0 0" />
    </svg>
  );
};

export const ICON_BUILDING = ({ classNames = "" }) => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
    >
      <g id="Group">
        <g id="Group_2">
          <g id="Group_3">
            <path
              id="Vector"
              d="M13.2 6.42231V7.42231H12.2H2.95658C2.64463 7.4231 2.34421 7.53467 2.10936 7.73342H2.95555H12.2H13.2V8.73342V30.689V31.689H12.2H2.95555H2.11063C2.34648 31.8885 2.64579 31.9993 2.95658 32.0001C2.95687 32.0001 2.95715 32.0001 2.95744 32.0001H30.687C30.6873 32.0001 30.6876 32.0001 30.6879 32.0001C30.9991 31.9993 31.2992 31.8882 31.5349 31.689H30.6889H27.2222H26.2222V30.689V24.9122C26.2214 24.6003 26.1099 24.2999 25.9111 24.065V24.9112V30.689V31.689H24.9111H20.2889H19.2889V30.689V24.9112V24.066C19.09 24.3005 18.9786 24.6005 18.9778 24.9122V30.689V31.689H17.9778H14.5111H13.5111V30.689V2.95564V2.1096C13.3119 2.34534 13.2008 2.64546 13.2 2.95667C13.2 2.95696 13.2 2.95724 13.2 2.95753L13.2 6.42231ZM1.95555 8.73342V7.88737C1.75631 8.12312 1.64524 8.42323 1.64444 8.73445C1.64444 8.73473 1.64444 8.73502 1.64444 8.73531V30.6871C1.64444 30.6874 1.64444 30.6877 1.64444 30.688C1.64523 30.9987 1.75604 31.2981 1.95555 31.5339V30.689V8.73342ZM31.6889 30.689L31.6889 31.5352C31.8876 31.3004 31.9992 30.9999 32 30.6879V2.95672C31.9992 2.6445 31.8885 2.34469 31.6901 2.10969L31.69 2.95568L31.6889 30.689ZM30.69 1.95564H31.5363C31.301 1.75651 31.0007 1.64531 30.6878 1.64453H14.5122C14.2002 1.64531 13.8998 1.75688 13.6649 1.95564H14.5111H30.69ZM24.9111 23.9112H25.7572C25.5214 23.712 25.2213 23.6009 24.9101 23.6001C24.9098 23.6001 24.9095 23.6001 24.9092 23.6001H20.2908C20.2905 23.6001 20.2902 23.6001 20.2899 23.6001C19.9782 23.6009 19.6782 23.7123 19.4437 23.9112H20.2889H24.9111ZM19.0051 16.9101L19.0059 16.9113C19.0199 16.9323 19.0436 16.9534 19.0751 16.9668C19.1001 16.9771 19.1307 16.9811 19.164 16.975C19.1951 16.9683 19.2221 16.9533 19.2432 16.9322C19.2643 16.9111 19.2793 16.884 19.2861 16.8529C19.2921 16.8196 19.2881 16.7892 19.2779 16.7642C19.2645 16.7326 19.2433 16.7089 19.2223 16.6949L19.2211 16.6941C19.193 16.6753 19.1626 16.6668 19.1333 16.6668C19.0907 16.6668 19.052 16.6838 19.0254 16.7106L19.0216 16.7143C18.9948 16.7409 18.9778 16.7797 18.9778 16.8223C18.9778 16.8516 18.9864 16.882 19.0051 16.9101ZM19.0051 12.2879L19.0059 12.289C19.0199 12.3101 19.0436 12.3313 19.0751 12.3446C19.1002 12.3548 19.1307 12.3589 19.164 12.3528C19.195 12.3461 19.2221 12.331 19.2432 12.31C19.2643 12.2889 19.2793 12.2618 19.286 12.2307C19.2921 12.1974 19.2881 12.1669 19.2779 12.1419C19.2645 12.1104 19.2433 12.0866 19.2223 12.0727L19.2211 12.0719C19.193 12.0531 19.1626 12.0445 19.1333 12.0445C19.0907 12.0445 19.052 12.0616 19.0253 12.0883L19.0216 12.0921C18.9948 12.1187 18.9778 12.1575 18.9778 12.2001C18.9778 12.2294 18.9864 12.2597 19.0051 12.2879ZM19.0051 7.66566L19.0059 7.66683C19.0199 7.68788 19.0436 7.70904 19.0752 7.72243C19.1002 7.73263 19.1307 7.73663 19.164 7.73058C19.195 7.72387 19.2221 7.70882 19.2432 7.68773C19.2643 7.66665 19.2793 7.63956 19.286 7.6085C19.2921 7.57518 19.2881 7.5447 19.2779 7.51967C19.2645 7.48812 19.2433 7.46442 19.2223 7.45043L19.2211 7.44965C19.193 7.43089 19.1626 7.42231 19.1333 7.42231C19.0907 7.42231 19.052 7.43934 19.0253 7.46611L19.0254 7.46612L19.0216 7.46988C18.9948 7.4965 18.9778 7.53524 18.9778 7.57786C18.9778 7.60717 18.9864 7.63752 19.0051 7.66566ZM25.9384 16.9101L25.9392 16.9113C25.9532 16.9323 25.9769 16.9535 26.0085 16.9669C26.0335 16.9771 26.064 16.9811 26.0973 16.975C26.1284 16.9683 26.1555 16.9533 26.1765 16.9322C26.1976 16.9111 26.2127 16.884 26.2194 16.8529C26.2254 16.8196 26.2214 16.7892 26.2112 16.7642C26.1978 16.7326 26.1767 16.7089 26.1556 16.6949L26.1545 16.6941C26.1263 16.6753 26.096 16.6668 26.0667 16.6668C26.024 16.6668 25.9853 16.6838 25.9587 16.7106L25.9549 16.7143C25.9281 16.7409 25.9111 16.7797 25.9111 16.8223C25.9111 16.8516 25.9197 16.882 25.9384 16.9101ZM25.9385 12.2879L25.9392 12.2891C25.9532 12.3101 25.9769 12.3313 26.0085 12.3446C26.0335 12.3548 26.064 12.3589 26.0973 12.3528C26.1284 12.3461 26.1554 12.331 26.1765 12.31C26.1976 12.2889 26.2127 12.2618 26.2194 12.2307C26.2254 12.1974 26.2214 12.1669 26.2112 12.1419C26.1978 12.1103 26.1767 12.0866 26.1556 12.0727L26.1545 12.0719C26.1263 12.0531 26.096 12.0445 26.0667 12.0445C26.024 12.0445 25.9853 12.0616 25.9587 12.0883L25.9549 12.0921C25.9281 12.1187 25.9111 12.1575 25.9111 12.2001C25.9111 12.2294 25.9197 12.2597 25.9385 12.2879ZM25.9385 7.66565L25.9392 7.66683C25.9532 7.68787 25.9769 7.70903 26.0085 7.72243C26.0335 7.73263 26.064 7.73663 26.0973 7.73058C26.1284 7.72387 26.1555 7.70882 26.1765 7.68774L26.8194 8.33056L26.1765 7.68774C26.1976 7.66665 26.2127 7.63955 26.2194 7.60849C26.2254 7.57518 26.2214 7.5447 26.2112 7.51967C26.1978 7.48812 26.1767 7.46441 26.1556 7.45043L26.1545 7.44965C26.1263 7.43089 26.096 7.42231 26.0667 7.42231C26.024 7.42231 25.9853 7.43934 25.9587 7.4661L25.9587 7.46611L25.9549 7.46988C25.9281 7.4965 25.9111 7.53524 25.9111 7.57786C25.9111 7.60717 25.9197 7.63752 25.9385 7.66565Z"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ICON_HOUSE = ({ classNames = "" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
    >
      <g id="Basic / Home_House">
        <path
          id="Vector"
          d="M26.666 13.3337V25.3337C26.666 26.8064 25.4721 28.0003 23.9993 28.0003H7.99935C6.52659 28.0003 5.33268 26.8064 5.33268 25.3337V13.3337M26.666 13.3337L29.3327 16.0003M26.666 13.3337L15.9993 2.66699L5.33268 13.3337M5.33268 13.3337L2.66602 16.0003M11.9993 28.0003V16.0003H19.9993V28.0003M21.3327 8.00033V4.00033H25.3327V12.0003"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ICON_EDIT_PENCIL_SQUARE = ({
  width = 24,
  height = 24,
  className = " w-6 h-6 ",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-square-pen-icon lucide-square-pen"
    >
      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
    </svg>
  );
};
